module.exports = __webpack_public_path__ + "img/xHover.1e798e24.svg";